function stripTrailingSlash(url: string): string {
  return url.replace(/\/$/, "");
}

function configuredTransactionMonitoringApiBase(): string | undefined {
  if (import.meta.env.DEV) {
    return (
      import.meta.env.VITE_TRANSACTION_MONITORING_API_URL?.trim() ??
      "http://127.0.0.1:3770"
    );
  }
  return import.meta.env.VITE_PUBLIC_TRANSACTION_MONITORING_API_URL?.trim();
}

export function hasTransactionMonitoringHostedConfig(
  env = import.meta.env,
): boolean {
  return Boolean(env.VITE_PUBLIC_TRANSACTION_MONITORING_API_URL?.trim());
}

export function isTransactionMonitoringE2EBypassEnabled(
  env = import.meta.env,
): boolean {
  return env.VITE_TRANSACTION_MONITORING_E2E_BYPASS === "true";
}

export function isTransactionMonitoringSurfaceEnabled(): boolean {
  if (
    import.meta.env.VITE_IS_PLAYWRIGHT === "true" ||
    isTransactionMonitoringE2EBypassEnabled()
  ) {
    return true;
  }
  if (import.meta.env.DEV) {
    return true;
  }
  return hasTransactionMonitoringHostedConfig();
}

export function transactionMonitoringApiBase(): string {
  const base = configuredTransactionMonitoringApiBase();
  if (!base?.trim()) {
    throw new Error(
      "VITE_PUBLIC_TRANSACTION_MONITORING_API_URL is required in production builds.",
    );
  }
  return stripTrailingSlash(base);
}
